import { UserSelectDto } from "definitions/poizon-sso";

export const isAdmin = (user: UserSelectDto | null) => {
  if (!user) return false;
  return ["SUPERUSER", "ADMIN"].includes(user.role);
};
